import { render, staticRenderFns } from "./ChooseOrderTwo.vue?vue&type=template&id=61bd1b69&scoped=true&"
import script from "./ChooseOrderTwo.vue?vue&type=script&lang=js&"
export * from "./ChooseOrderTwo.vue?vue&type=script&lang=js&"
import style0 from "./ChooseOrderTwo.vue?vue&type=style&index=0&id=61bd1b69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bd1b69",
  null
  
)

export default component.exports